import WorkspaceAPI from '../WorkspaceAPI';
import {
  WorkspaceInheritanceAPIResponse,
  WorkspaceInheritanceCreateRequest,
} from './WorkspaceInheritanceAPI.model';
import { fromBase64, toBase64 } from '../../../shared/util/base64';
import { WorkspaceAPIResponse } from '../WorkspaceAPI.model';
import Environment from '../../../shared/constants/Environment';

const billingPath = Environment.backendAPIBilling;

const WorkspaceInheritanceAPI = WorkspaceAPI.injectEndpoints({
  endpoints(build) {
    return {
      /// {{BaseURL}}/api/billing/:encodedWorkspaceId/subworkspaces
      getChildren: build.query<WorkspaceInheritanceAPIResponse, string>({
        query: (workspaceId) => ({
          url: `${billingPath}/${toBase64(workspaceId)}/subworkspaces`,
        }),
        providesTags: ['cancel-self', 'workspace-actions'],
      }),
      createWorkspace: build.mutation<
        WorkspaceAPIResponse,
        { formData: WorkspaceInheritanceCreateRequest; workspaceId: string }
      >({
        query: ({ formData, workspaceId }) => ({
          url: `${billingPath}/${toBase64(workspaceId)}/subworkspaces/create`,
          method: 'POST',
          data: formData,
        }),
        transformResponse: (response: WorkspaceAPIResponse) => {
          return {
            ...response,
            id: fromBase64(response.id),
          };
        },
        invalidatesTags: ['workspace-actions'],
      }),
      updateQuota: build.mutation<
        null,
        {
          quota: { users: number; devices: number };
          workspaceId: string;
          subworkspaceId: string;
        }
      >({
        query: ({ workspaceId, quota, subworkspaceId }) => ({
          url: `${billingPath}/${toBase64(
            workspaceId
          )}/subworkspaces/${toBase64(subworkspaceId)}/quota`,
          method: 'PUT',
          data: quota,
        }),
        invalidatesTags: ['workspace-actions'],
      }),
      removeSubworkspace: build.mutation<
        void,
        { workspaceId: string; subworkspaceId: string }
      >({
        query: ({ workspaceId, subworkspaceId }) => ({
          url: `${billingPath}/${toBase64(
            workspaceId
          )}/subworkspaces/${toBase64(subworkspaceId)}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['workspace-actions'],
      }),
    };
  },
});

export default WorkspaceInheritanceAPI;
